export const SIDEBAR_HIDDEN = 'sidebar_hidden';
export const DEFAULT_AVATAR_NAME = 'default-avatar';
export const DEFAULT_AVATAR_PATH = 'avatars/default-avatar.svg';
export const DEFAULT_AVATAR_PATH_IOS = 'avatars/default-avatar.png';
export const ANONYMOUS_NAME = 'Anonymous';

export const ALL = [SIDEBAR_HIDDEN];
